import LogoImg from "../../images/LogoImg";
import registrationImg from "../../images/registrationImg.png";
import { Button, Typography } from "../../components/common";

interface CommonAuthLayoutProps {
  children: React.ReactNode;
  isLogin: boolean;
  onNavigate: () => void;
}

const CommonAuthLayout = ({
  children,
  isLogin,
  onNavigate,
}: CommonAuthLayoutProps) => {
  return (
    <div className="flex flex-row justify-between sm:px-14 px-4 py-6 bg-background min-h-screen">
      <div className="md:flex hidden flex-col  justify-between w-full">
        <LogoImg className="mt-8" />
        <img
          src={registrationImg}
          alt="Registration Img"
          className="w-fit m-auto"
        />
        <span />
      </div>
      <div className="max-w-[752px] w-full bg-pd-white rounded-[32px] p-4 flex flex-col">
        {!isLogin && (
          <div className="flex justify-end items-center gap-4 pr-6">
            <Typography variant="small">
              Already have an account?
            </Typography>
            <Button
              label="Sign in"
              variant="filled"
              size="small"
              className="rounded-lg font-semibold px-4 py-2 bg-secondary-green !text-primary hover:!text-white"
              onClick={onNavigate}
            />
          </div>
        )}
        <div className="m-auto">{children}</div>
      </div>
    </div>
  );
};

export default CommonAuthLayout;
